<div *ngIf="isLoading" class="loader my-5"></div>

<div *ngIf="!isLoading" class="classes-area pt-4 ptb-lg-100">
	<div class="container">
		<h5 class="account-heading">Payment Methods</h5>
        <div class="row">
            <div class="col-lg-8 col-sm-12">
                <ul class="payment-method-list">
                    <li class="payment-method-list-item" *ngFor="let paymentMethod of paymentMethods">
                        <div class="card mb-3 py-0" *ngIf="paymentMethod.type === 'card'">
                          <div class="row g-0 d-table">
                            <div class="col-2 d-table-cell">
                              <img [src]="cardImage(paymentMethod.card.brand)" [alt]="paymentMethod.card.brand" class="card-image"/>
                            </div>
                            <div class="col-9 d-table-cell">
                              <div class="card-body">
                                  <span class="card-text">Card ending in {{paymentMethod.card.last4}}
                                      <span class="default-card-tag" *ngIf="paymentMethod.is_default">Default</span>
                                  </span>
                              </div>
                            </div>
                            <div class="col-1 d-table-cell align-middle h-align-right">
                              <i class="bi bi-three-dots-vertical three-dots" *ngIf="!paymentMethod.is_default" (click)="toggleMenu($event)"></i>
                              <div class="dropdown-menu">
                                  <ul>
                                    <li (click)="setPaymentMethodDefault(paymentMethod.id)">Set Default</li>
                                    <li (click)="removeCard(paymentMethod.id)">Remove</li>
                                  </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card mb-3 py-0 bank-card" *ngIf="paymentMethod.type === 'us_bank_account'" [class.pending]="isPendingUsBankAccount(paymentMethod)">
                          <button class="verify-btn" *ngIf="isPendingUsBankAccount(paymentMethod)" (click)="openVerifyBankAccount(paymentMethod)">Verify</button>
                          <div class="row g-0 d-table">
                            <div class="col-2 d-table-cell">
                              <img [src]="cardImage(paymentMethod.type)" alt="Bank Account" class="card-image"/>
                            </div>
                            <div class="col-9 d-table-cell">
                              <div class="card-body">
                                  <span class="card-text">Account number ending in {{paymentMethod.us_bank_account.last4}}
                                      <span class="default-card-tag" *ngIf="paymentMethod.is_default">Default</span>
                                      <span class="pending-tag" *ngIf="isPendingUsBankAccount(paymentMethod)">Pending verification</span>
                                  </span>
                              </div>
                            </div>
                            <div class="col-1 d-table-cell align-middle h-align-right">
                              <i
                                class="bi bi-three-dots-vertical three-dots"
                                *ngIf="!paymentMethod.is_default && !isPendingUsBankAccount(paymentMethod)"
                                (click)="toggleMenu($event)"></i>
                              <div class="dropdown-menu" *ngIf="!isPendingUsBankAccount(paymentMethod)">
                                  <ul>
                                    <li (click)="setPaymentMethodDefault(paymentMethod.id)">Set Default</li>
                                    <li (click)="removeCard(paymentMethod.id)">Remove</li>
                                  </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <a href="javascript:void(0)" (click)="openAddPaymentMethodPopup()" class="add-card-link">+ Add a new payment method</a>
            </div>
        </div>
	</div>
</div>